"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getI18nConfiguration = getI18nConfiguration;
exports.getI18nFolderNames = getI18nFolderNames;
/**
 * Get i18n configuration.
 *
 * @param env cds environment
 * @returns cds i18n configuration
 */
function getI18nConfiguration(env) {
    const { default_language: defaultLanguage, fallback_bundle: fallbackLanguage, file, folders } = env?.i18n ?? {};
    return {
        defaultLanguage: defaultLanguage ?? 'en',
        fallbackLanguage: fallbackLanguage ?? '',
        baseFileName: file ?? 'i18n',
        folders: folders ?? ['_i18n', 'i18n']
    };
}
/**
 * Returns a list of allowed i18n folder names, where translation files can be found.
 *
 * @param env cds environment
 * @returns array of folder names
 */
function getI18nFolderNames(env) {
    const { folders } = getI18nConfiguration(env);
    return folders;
}
//# sourceMappingURL=config.js.map